module.exports = __webpack_public_path__ + "fonts/Inter-Bold.ba8d154.ttf";